import type { BingoGame } from "bingo/types/bingo-game.model";
import { config } from "config";

export class BingoGameService {
  private static headers() {
    return {
      Authorization: `Bearer ${JSON.parse(
        sessionStorage.getItem("quizToken")!,
      )}`,
    };
  }

  getDrawNumberslist(bingoGameId: string): Promise<BingoGame> {
    return fetch(`${config.apiRoot}/bingo-games/${bingoGameId}`, {
      headers: BingoGameService.headers(),
    }).then((resp) => resp.json());
  }

  checkWinner(bingoData: {
    bingoEntries: string;
    playerId: string;
    partitionId: string;
    bingoGameId: string;
  }): Promise<string> {
    return fetch(`${config.apiRoot}/check-bingo-winner`, {
      method: "POST",
      headers: BingoGameService.headers(),
      body: JSON.stringify(bingoData),
    }).then((resp) => resp.json());
  }

  getBingoGame(bingoGameId: string): Promise<BingoGame> {
    return fetch(`${config.apiRoot}/bingo-games/${bingoGameId}`, {
      headers: BingoGameService.headers(),
    }).then((resp) => {
      if (!resp.ok) {
        throw new Error(`Error fetching bingo game: ${resp.statusText}`);
      }
      return resp.json() as Promise<BingoGame>; // Type assertion for clarity
    });
  }
}
